import { render, staticRenderFns } from "./Payementtouch_succes.vue?vue&type=template&id=134cd0e5&scoped=true"
import script from "./Payementtouch_succes.vue?vue&type=script&lang=js"
export * from "./Payementtouch_succes.vue?vue&type=script&lang=js"
import style0 from "./Payementtouch_succes.vue?vue&type=style&index=0&id=134cd0e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134cd0e5",
  null
  
)

export default component.exports